module.exports = __webpack_public_path__ + "static/marcos-2be3a3cd6073107432c908ee5c53bb69.png";